import React from "react";
import { Link } from "react-router-dom";
import Typed from "react-typed";

const Banner = () => {
  return (
    <div className="bg-black pl-10 mt-[-20px]  flex mb-16 lg:pr-16 lg:mb-0 pb-10 justify-evenly items-center md:flex-row min-h-full h-[80vh] flex-col-reverse lg:flex-row lg:min-h-[60vh]">
      <div
        data-aos-delay="1000"
        data-aos-duration="3000"
        data-aos="fade-right"
        className="lg:w-6/12 mx-auto"
      >
        <p className="text-base-100 font-bold text-3xl lg:text-5xl py-4">
          <span className="text-secondary font-medium ">Hey!</span> I am Kibria.
        </p>
        <Typed
          className="lg:text-3xl text-xl pr-5 lg:tracking-wider font-semibold h_tag text-success"
          strings={[
            "I'm a Front End Developer",
            "I Love Ui designing",
            "I am comfortable with React.js",
          ]}
          typeSpeed={150}
          backSpeed={100}
          loop
        />
        <p className="text-accent w-8/12 mt-3">
          I build interactive websites that run across platform & device. I have
          meet some amazing engineer in 'Phero' that made me much better.
        </p>
      </div>
      <div data-aos="zoom-in" data-aos-delay="300" data-aos-duration="1000">
        <svg
          id="triangle"
          className="svg lg:w-[300px] lg:h-[300px] md:w-[250px]"
          viewBox="-3 -4 39 39"
        >
          <polygon
            className="polygon"
            fill="rgba(52, 152, 219, .4)"
            stroke="#C32285"
            stroke-width="1"
            points="16,0 32,32 0,32"
          ></polygon>
        </svg>
      </div>
    </div>
  );
};

export default Banner;
// 2980b9
